import React from "react";
import { CopyToCliboard } from "@components/CustomTable/helpers";

// Index constants
export const FIRST_INDEX = 0;
// Value constants
export const ZERO_VALUE = 0;
export const ONE_VALUE = 1;

// Timeout constants
export const REDUCE_TIMEOUT = 0;
export const TOOLTIP_TIMEOUT = 150;

// Filter values for corrective action dropdown
export const getFilterValues = (translate) => ({
  values: [
    {
      value: "MANUALLY_CLEARED",
      displayName: translate("shared.manuallyCleared"),
      className: "text-green-600 text-semibold",
    },
    {
      value: "RESULTANT_EXCEPTION",
      displayName: translate("shared.resultantException"),
      className: "text-orange-600 text-semibold",
    },
  ],
});

// Table columns configuration
export const getTableColumns = (translate, FormatWithCommas, setCurrentTooltip, TOOLTIP_TIMEOUT) => [
  {
    accessorKey: "ReconciliationStreamName",
    header: "Reconciliation Stream",
    size: 230,
    truncate: true,
  },
  {
    accessorKey: "DataAcquisitionName",
    header: "Data Source",
    size: 150,
  },
  {
    accessorKey: "AreaName",
    header: "Area",
    size: 160,
  },
  {
    accessorKey: "OutletName",
    header: "Outlet",
    size: 160,
  },
  {
    accessorKey: "TransactionTerminalCode",
    header: "Terminal",
    size: 150,
  },
  {
    accessorKey: "Amount",
    header: "Amount",
    size: 150,
    sortable: true,
    processFilterValue: (value, row) => {
      return row.Amount.toString();
    },
    cell: ({ row }) => {
      return (
        <span className="flex flex-col items-center justify-center group font-normal">
          <span>{`${row.original.Currency} ${FormatWithCommas(
            row.original.Amount
          )}`}</span>
        </span>
      );
    },
    filterType: "amount",
    operator: "EQ",
  },
  {
    accessorKey: "RecordReference",
    header: "Record Reference",
    size: 150,
  },
  {
    accessorKey: "RecordDate",
    header: "Record Date",
    size: 180,
    splitCellValue: "T",
  },
  {
    accessorKey: "RecordType",
    header: "Record Type",
    size: 150,
  },
  {
    accessorKey: "Attributes",
    header: "Record Attributes",
    size: 150,
    displayInPopup: true,
    popupCellDisplay: (value) => {
      return (
        <div
          data-tooltip-id="attributes-tooltip"
          onMouseOver={() => {
            setCurrentTooltip(value);
          }}
          onMouseOut={() =>
            setTimeout(() => {
              setCurrentTooltip(null);
            }, TOOLTIP_TIMEOUT)
          }
          className="relative text-primary-400 font-semibold"
        >
          {"("}
          {value.length}
          {")"}
        </div>
      );
    },
    popupContent: (row) => {
      const value = row.Attributes;
      return (
        <div className="relative ">
          <div className="flex dark:text-white flex-col min-w-[400px] transition-all bg-primary-dark text-[#777f9e] text-14 rounded-lg px-[2px] py-[8px] mb-3 opacity-100">
            {value &&
              value.map((attr, index) => (
                <div
                  key={index}
                  className="flex flex-row justify-between gap-2 mb-[2px]"
                >
                  <span className="py-[2px] whitespace-nowrap text-xs font-semibold">
                    {attr.Key}
                  </span>
                  <span className="relative py-[2px] flex gap-2 items-center px-[8px] whitespace-nowrap ltr:text-right rtl:text-left text-sm">
                    {attr.Value}
                    <div className=" absolute left-0 w-full justify-center flex opacity-0 hover:opacity-100 bg-gray-300 bg-opacity-50 rounded">
                      <CopyToCliboard size="5" value={attr.Value} />
                    </div>
                  </span>
                </div>
              ))}
          </div>
        </div>
      );
    },
  },
  {
    accessorKey: "PaymentMethod",
    header: "Payment Method",
    size: 180,
  },
];
